export const PRIMARY_FONT = "'Public Sans', sans-serif";
export const SECONDARY_FONT = 'Druk Wide';
